import {Text, TextProps} from '@/components/ui/text/Text'
import styled, {css} from 'styled-components'

export const StyledAgendaCalendarLoadingWrapper = styled.div(
    ({theme: {spacing, zIndex, palette}}) => css`
        position: fixed;
        bottom: ${spacing * 6}px;
        right: ${spacing * 6}px;
        z-index: ${zIndex.modal};

        & > svg {
            color: ${palette.neutral['400']};
        }
    `
)

export const StyledAgendaMonthHeader = styled(Text)<TextProps>(
    ({theme: {typography}}) => css`
        ${typography.textXs};
        text-transform: capitalize;
    `
)

export const StyledAgendaCalendarLockOverlay = styled.div(
    ({theme: {palette, zIndex, opacities}}) => css`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${palette.neutral['50']}${opacities['90']};
        z-index: ${zIndex.modal};
        & div {
            pointer-events: none;
        }
    `
)
